// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.font {
  min-height: 100vh;
  height: 100%;
  background-color: #000215;
}

h1,
h2 {
  text-align: center;
}

.title,
.date {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000215;
  color: #fefcf9;
  height: 50px;
  font-style: italic;
  margin-bottom: 0;
}

.ticket-all {
  display: flex;
  flex: 2;
  gap: 16px;
  color: white;
  background-color: #000215;
  height: -webkit-fill-available;
  align-items: stretch;
}
.ticket-all .tickets-home,
.ticket-all .tickets-road {
  display: flex;
  flex: 1;
  flex-direction: column;
  font-size: 17px;
  font-weight: bold;
  min-height: 200px;
  padding: 16px;
  border-radius: 14px;
  margin-bottom: 10px;
  background: rgba(255, 255, 255, 0.02);
}
.ticket-all .tickets-home h1,
.ticket-all .tickets-road h1 {
  color: #fefcf9;
  font-size: 20px;
  margin-bottom: 18px;
}
.ticket-all .tickets-home .top-players-main-container,
.ticket-all .tickets-road .top-players-main-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}
.ticket-all .tickets-home .top-players-main-container .points-container,
.ticket-all .tickets-home .top-players-main-container .assist-container,
.ticket-all .tickets-home .top-players-main-container .rebonds-container,
.ticket-all .tickets-road .top-players-main-container .points-container,
.ticket-all .tickets-road .top-players-main-container .assist-container,
.ticket-all .tickets-road .top-players-main-container .rebonds-container {
  display: flex;
  flex-direction: column;
}
.ticket-all .tickets-home .top-players-main-container .stats-card,
.ticket-all .tickets-home .top-players-main-container .points-container,
.ticket-all .tickets-home .top-players-main-container .assist-container,
.ticket-all .tickets-home .top-players-main-container .rebonds-container,
.ticket-all .tickets-road .top-players-main-container .stats-card,
.ticket-all .tickets-road .top-players-main-container .points-container,
.ticket-all .tickets-road .top-players-main-container .assist-container,
.ticket-all .tickets-road .top-players-main-container .rebonds-container {
  background: rgba(129, 192, 228, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 14px;
  min-height: 190px;
}
.ticket-all .tickets-home .top-players-main-container .stats-card h2,
.ticket-all .tickets-home .top-players-main-container .points-container h2,
.ticket-all .tickets-home .top-players-main-container .assist-container h2,
.ticket-all .tickets-home .top-players-main-container .rebonds-container h2,
.ticket-all .tickets-road .top-players-main-container .stats-card h2,
.ticket-all .tickets-road .top-players-main-container .points-container h2,
.ticket-all .tickets-road .top-players-main-container .assist-container h2,
.ticket-all .tickets-road .top-players-main-container .rebonds-container h2 {
  font-size: 18px;
  margin-bottom: 12px;
  color: #fff;
}
.ticket-all .tickets-home .top-players-main-container .stats-card .ticket-item,
.ticket-all .tickets-home .top-players-main-container .stats-card .player-item,
.ticket-all .tickets-home .top-players-main-container .points-container .ticket-item,
.ticket-all .tickets-home .top-players-main-container .points-container .player-item,
.ticket-all .tickets-home .top-players-main-container .assist-container .ticket-item,
.ticket-all .tickets-home .top-players-main-container .assist-container .player-item,
.ticket-all .tickets-home .top-players-main-container .rebonds-container .ticket-item,
.ticket-all .tickets-home .top-players-main-container .rebonds-container .player-item,
.ticket-all .tickets-road .top-players-main-container .stats-card .ticket-item,
.ticket-all .tickets-road .top-players-main-container .stats-card .player-item,
.ticket-all .tickets-road .top-players-main-container .points-container .ticket-item,
.ticket-all .tickets-road .top-players-main-container .points-container .player-item,
.ticket-all .tickets-road .top-players-main-container .assist-container .ticket-item,
.ticket-all .tickets-road .top-players-main-container .assist-container .player-item,
.ticket-all .tickets-road .top-players-main-container .rebonds-container .ticket-item,
.ticket-all .tickets-road .top-players-main-container .rebonds-container .player-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
  font-size: 15px;
  line-height: 1.4;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}
.ticket-all .tickets-home .top-players-main-container .stats-card .ticket-item:last-child,
.ticket-all .tickets-home .top-players-main-container .stats-card .player-item:last-child,
.ticket-all .tickets-home .top-players-main-container .points-container .ticket-item:last-child,
.ticket-all .tickets-home .top-players-main-container .points-container .player-item:last-child,
.ticket-all .tickets-home .top-players-main-container .assist-container .ticket-item:last-child,
.ticket-all .tickets-home .top-players-main-container .assist-container .player-item:last-child,
.ticket-all .tickets-home .top-players-main-container .rebonds-container .ticket-item:last-child,
.ticket-all .tickets-home .top-players-main-container .rebonds-container .player-item:last-child,
.ticket-all .tickets-road .top-players-main-container .stats-card .ticket-item:last-child,
.ticket-all .tickets-road .top-players-main-container .stats-card .player-item:last-child,
.ticket-all .tickets-road .top-players-main-container .points-container .ticket-item:last-child,
.ticket-all .tickets-road .top-players-main-container .points-container .player-item:last-child,
.ticket-all .tickets-road .top-players-main-container .assist-container .ticket-item:last-child,
.ticket-all .tickets-road .top-players-main-container .assist-container .player-item:last-child,
.ticket-all .tickets-road .top-players-main-container .rebonds-container .ticket-item:last-child,
.ticket-all .tickets-road .top-players-main-container .rebonds-container .player-item:last-child {
  border-bottom: none;
}
.ticket-all .tickets-home .top-players-main-container .stats-card .ticket-item .player-name,
.ticket-all .tickets-home .top-players-main-container .stats-card .player-item .player-name,
.ticket-all .tickets-home .top-players-main-container .points-container .ticket-item .player-name,
.ticket-all .tickets-home .top-players-main-container .points-container .player-item .player-name,
.ticket-all .tickets-home .top-players-main-container .assist-container .ticket-item .player-name,
.ticket-all .tickets-home .top-players-main-container .assist-container .player-item .player-name,
.ticket-all .tickets-home .top-players-main-container .rebonds-container .ticket-item .player-name,
.ticket-all .tickets-home .top-players-main-container .rebonds-container .player-item .player-name,
.ticket-all .tickets-road .top-players-main-container .stats-card .ticket-item .player-name,
.ticket-all .tickets-road .top-players-main-container .stats-card .player-item .player-name,
.ticket-all .tickets-road .top-players-main-container .points-container .ticket-item .player-name,
.ticket-all .tickets-road .top-players-main-container .points-container .player-item .player-name,
.ticket-all .tickets-road .top-players-main-container .assist-container .ticket-item .player-name,
.ticket-all .tickets-road .top-players-main-container .assist-container .player-item .player-name,
.ticket-all .tickets-road .top-players-main-container .rebonds-container .ticket-item .player-name,
.ticket-all .tickets-road .top-players-main-container .rebonds-container .player-item .player-name {
  color: #e5e7eb;
  font-weight: 600;
  line-height: 1.25;
}
.ticket-all .tickets-home .top-players-main-container .stats-card .ticket-item .player-value,
.ticket-all .tickets-home .top-players-main-container .stats-card .player-item .player-value,
.ticket-all .tickets-home .top-players-main-container .points-container .ticket-item .player-value,
.ticket-all .tickets-home .top-players-main-container .points-container .player-item .player-value,
.ticket-all .tickets-home .top-players-main-container .assist-container .ticket-item .player-value,
.ticket-all .tickets-home .top-players-main-container .assist-container .player-item .player-value,
.ticket-all .tickets-home .top-players-main-container .rebonds-container .ticket-item .player-value,
.ticket-all .tickets-home .top-players-main-container .rebonds-container .player-item .player-value,
.ticket-all .tickets-road .top-players-main-container .stats-card .ticket-item .player-value,
.ticket-all .tickets-road .top-players-main-container .stats-card .player-item .player-value,
.ticket-all .tickets-road .top-players-main-container .points-container .ticket-item .player-value,
.ticket-all .tickets-road .top-players-main-container .points-container .player-item .player-value,
.ticket-all .tickets-road .top-players-main-container .assist-container .ticket-item .player-value,
.ticket-all .tickets-road .top-players-main-container .assist-container .player-item .player-value,
.ticket-all .tickets-road .top-players-main-container .rebonds-container .ticket-item .player-value,
.ticket-all .tickets-road .top-players-main-container .rebonds-container .player-item .player-value {
  color: #fff;
  font-weight: 800;
  white-space: nowrap;
}
.ticket-all .tickets-home .top-players-main-container .points-container .player-value,
.ticket-all .tickets-road .top-players-main-container .points-container .player-value {
  color: #22c55e;
}
.ticket-all .tickets-home .top-players-main-container .assist-container .player-value,
.ticket-all .tickets-road .top-players-main-container .assist-container .player-value {
  color: #60a5fa;
}
.ticket-all .tickets-home .top-players-main-container .rebonds-container .player-value,
.ticket-all .tickets-road .top-players-main-container .rebonds-container .player-value {
  color: #f59e0b;
}

.ticket-location {
  display: flex;
  flex-direction: row;
  gap: 20px;
}
.ticket-location .stats-card {
  background: rgba(129, 192, 228, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 14px;
  min-height: 5px;
}
.ticket-location .stats-card .ticket-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
  font-size: 15px;
  line-height: 1.4;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}
.ticket-location .stats-card .ticket-item:last-child {
  border-bottom: none;
}
.ticket-location .tickets-road,
.ticket-location .tickets-home {
  flex: 1;
  min-width: 0;
}
.ticket-location .tickets-road h1,
.ticket-location .tickets-home h1 {
  color: #fefcf9;
  margin-bottom: 14px;
}
.ticket-location .tickets-road .ticket-item,
.ticket-location .tickets-home .ticket-item {
  display: block;
  padding: 10px 12px;
  margin-bottom: 10px;
  line-height: 1.8;
  box-sizing: border-box;
}
.ticket-location .tickets-road .ticket-item .badge,
.ticket-location .tickets-road .ticket-item .play-badge,
.ticket-location .tickets-home .ticket-item .badge,
.ticket-location .tickets-home .ticket-item .play-badge {
  margin-left: 10px;
}

/* zone cartes */
.ticket-sort {
  display: flex;
  flex-direction: column;
  padding: 10px 12px;
  color: white;
  background-color: #000215;
}
.ticket-sort h1 {
  text-align: center;
  margin-bottom: 12px;
  width: 100%;
}
.ticket-sort .ticket-card {
  width: 600px;
  background: rgba(129, 192, 228, 0.3);
  border: 2px solid #2a2a2a;
  border-radius: 14px;
  padding: 10px 14px;
  margin-bottom: 10px;
  color: #fff;
  transition: all 0.2s ease;
  box-sizing: border-box;
}
.ticket-sort .ticket-card .ticket-card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.ticket-sort .ticket-card .ticket-card-top .ticket-rank {
  font-size: 18px;
  font-weight: 800;
  line-height: 1;
}
.ticket-sort .ticket-card .ticket-card-top .ticket-scoring {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  font-size: 15px;
  font-weight: 700;
  color: #22c55e;
}
.ticket-sort .ticket-card .ticket-card-top .ticket-confidence {
  font-size: 15px;
  font-weight: 700;
  text-align: right;
  color: #60a5fa;
}
.ticket-sort .ticket-card .ticket-card-top .ticket-confidence.positive {
  color: #60a5fa;
}
.ticket-sort .ticket-card .ticket-card-top .ticket-confidence.negative {
  color: #ef4444;
}
.ticket-sort .ticket-card .ticket-context-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}
.ticket-sort .ticket-card .ticket-context-line .ticket-context {
  font-size: 15px;
  color: #bdbdbd;
  font-weight: 600;
  margin-right: 4px;
}
.ticket-sort .ticket-card .ticket-context-line .ticket-badges-right {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.ticket-sort .ticket-card .ticket-match-line {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 4px;
}
.ticket-sort .ticket-card .ticket-match-line .ticket-team {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  line-height: 1.2;
}
.ticket-sort .ticket-card .ticket-match-line .ticket-opponent {
  font-size: 13px;
  color: #8f8f8f;
  white-space: nowrap;
  text-align: right;
}
.ticket-sort .ticket-card .ticket-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #d0d0d0;
}
.ticket-sort .ticket-card .ticket-meta .meta-left {
  display: flex;
  align-items: center;
  gap: 6px;
}
.ticket-sort .ticket-card .ticket-meta .meta-right {
  font-weight: 700;
  color: #fff;
}
.ticket-sort .ticket-card .ticket-meta .separator {
  margin: 0 4px;
  color: #888;
}
.ticket-sort .ticket-card .ticket-meta .odds {
  color: #fff;
  font-weight: 700;
}
.ticket-sort .ticket-card .ticket-meta .odds strong {
  font-weight: 800;
  color: #fff;
}
.ticket-sort .ticket-card .ticket-model {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.2;
}
.ticket-sort .ticket-card .ticket-model .delta {
  color: #22c55e;
}
.ticket-sort .ticket-card .ticket-model .rank.positive {
  color: #60a5fa;
}
.ticket-sort .ticket-card .ticket-model .rank.negative {
  color: #ef4444;
}

.badge,
.play-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 20px;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}

.play-badge {
  background: rgba(255, 140, 0, 0.15);
  color: #ffb347;
}

.badge {
  /* 🥇 PREMIUM = OR */
  /* 🥈 ELITE = ARGENT */
  /* 🥉 CORE = BRONZE */
}
.badge.under-strong {
  background: linear-gradient(135deg, #1d4ed8, #60a5fa);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 0 6px rgba(59, 130, 246, 0.45);
}
.badge.under {
  background: linear-gradient(135deg, #60a5fa, #93c5fd);
  color: #0b1a2b;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.badge.over {
  background: linear-gradient(135deg, #fb923c, #f59e0b);
  color: #1f1303;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.badge.over-strong {
  background: linear-gradient(135deg, #ef4444, #b91c1c);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 0 6px rgba(239, 68, 68, 0.45);
}
.badge.premium, .badge.elite, .badge.core {
  border-radius: 999px;
  padding: 3px 8px;
  font-weight: 800;
  letter-spacing: 0.3px;
}
.badge.premium {
  background: linear-gradient(135deg, #ffd700, #facc15);
  color: #000;
  box-shadow: 0 0 6px rgba(255, 215, 0, 0.5);
  transform: scale(1.05);
}
.badge.elite {
  background: linear-gradient(135deg, #d1d5db, #9ca3af);
  color: #000;
  box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
}
.badge.core {
  background: linear-gradient(135deg, #cd7f32, #92400e);
  color: #fff;
  box-shadow: 0 0 4px rgba(205, 127, 50, 0.4);
}

.ticket-location {
  display: flex;
  flex-direction: row;
  gap: 16px;
}
.ticket-location .tickets-road,
.ticket-location .tickets-home {
  flex: 1;
  display: flex;
  flex-direction: column;
  font-size: 17px;
  font-weight: bold;
  min-height: 200px;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 10px;
}
.ticket-location .tickets-road h1,
.ticket-location .tickets-home h1 {
  color: #fefcf9;
  margin-bottom: 12px;
}
.ticket-location .tickets-road .ticket-item,
.ticket-location .tickets-home .ticket-item {
  display: block;
  padding: 6px 0;
  font-size: large;
  line-height: 1;
}
.ticket-location .tickets-road .ticket-item .badge,
.ticket-location .tickets-road .ticket-item .play-badge,
.ticket-location .tickets-home .ticket-item .badge,
.ticket-location .tickets-home .ticket-item .play-badge {
  margin-left: 10px;
}
.ticket-location .tickets-home {
  margin-left: 5px;
}

.ticket-road,
.ticket-home,
.tickets-road,
.tickets-home,
.ticket-sort {
  border-radius: 14px;
  padding: 14px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.12), 0 0 40px rgba(255, 255, 255, 0.08), 0 0 80px rgba(255, 255, 255, 0.04);
  transition: all 0.25s ease;
}

@media (max-width: 1100px) {
  .ticket-all {
    flex-direction: column;
  }
  .ticket-all .tickets-home .top-players-main-container,
  .ticket-all .tickets-road .top-players-main-container {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/tickets/tickets.component.scss","webpack://./src/utilities/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,iBAAA;EACA,YAAA;EACA,yBCLY;ADKd;;AAGA;;EAEE,kBAAA;AAAF;;AAGA;;EAEE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBClBY;EDmBZ,cAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,yBC9BY;ED+BZ,8BAAA;EACA,oBAAA;AAAF;AAEE;;EAEE,aAAA;EACA,OAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;AAAJ;AAEI;;EACE,cC5CQ;ED6CR,eAAA;EACA,mBAAA;AACN;AAEI;;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AACN;AACM;;;;;;EAGE,aAAA;EACA,sBAAA;AAIR;AADM;;;;;;;;EAIE,oCAAA;EACA,2CAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;AAOR;AALQ;;;;;;;;EACE,eAAA;EACA,mBAAA;EACA,WAAA;AAcV;AAXQ;;;;;;;;;;;;;;;;EAEE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kDAAA;AA2BV;AAzBU;;;;;;;;;;;;;;;;EACE,mBAAA;AA0CZ;AAvCU;;;;;;;;;;;;;;;;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;AAwDZ;AArDU;;;;;;;;;;;;;;;;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;AAsEZ;AAjEM;;EACE,cAAA;AAoER;AAjEM;;EACE,cAAA;AAoER;AAjEM;;EACE,cAAA;AAoER;;AA9DA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAiEF;AA/DE;EACM,oCAAA;EACA,2CAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AAiER;AA/DQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kDAAA;AAiEV;AA/DU;EACE,mBAAA;AAiEZ;AA7DE;;EAEE,OAAA;EACA,YAAA;AA+DJ;AA7DI;;EACE,cC1JQ;ED2JR,mBAAA;AAgEN;AA7DI;;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AAgEN;AA9DM;;;;EAEE,iBAAA;AAkER;;AA5DA,gBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBCvLY;ADsPd;AA7DE;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;AA+DJ;AA5DE;EACE,YAAA;EAEA,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;EACA,sBAAA;AA6DJ;AA3DI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AA6DN;AA3DM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA6DR;AA1DM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,OAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA4DR;AAzDM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AA2DR;AAzDQ;EACE,cAAA;AA2DV;AAxDQ;EACE,cAAA;AA0DV;AArDI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAuDN;AArDM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAuDR;AApDM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;AAsDR;AAlDI;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,SAAA;EACA,kBAAA;AAoDN;AAlDM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAoDR;AAjDM;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AAmDR;AA/CI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAiDN;AA/CM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAiDR;AA9CM;EACE,gBAAA;EACA,WAAA;AAgDR;AA7CM;EACE,aAAA;EACA,WAAA;AA+CR;AA5CM;EACE,WAAA;EACA,gBAAA;AA8CR;AA5CQ;EACE,gBAAA;EACA,WAAA;AA8CV;AAzCI;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA2CN;AAzCM;EACE,cAAA;AA2CR;AAvCQ;EACE,cAAA;AAyCV;AAtCQ;EACE,cAAA;AAwCV;;AAjCA;;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAoCF;;AAjCA;EACE,mCAAA;EACA,cAAA;AAoCF;;AAjCA;EAoCE,oBAAA;EAQA,sBAAA;EAOA,qBAAA;AAZF;AAtCE;EACE,qDAAA;EACA,WAAA;EACA,2CAAA;EACA,4CAAA;AAwCJ;AArCE;EACE,qDAAA;EACA,cAAA;EACA,0CAAA;AAuCJ;AApCE;EACE,qDAAA;EACA,cAAA;EACA,0CAAA;AAsCJ;AAnCE;EACE,qDAAA;EACA,WAAA;EACA,2CAAA;EACA,2CAAA;AAqCJ;AAlCE;EAGE,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AAkCJ;AA9BE;EACE,qDAAA;EACA,WAAA;EACA,0CAAA;EACA,sBAAA;AAgCJ;AA5BE;EACE,qDAAA;EACA,WAAA;EACA,4CAAA;AA8BJ;AA1BE;EACE,qDAAA;EACA,WAAA;EACA,2CAAA;AA4BJ;;AAxBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA2BF;AAzBE;;EAEE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AA2BJ;AAzBI;;EACE,cCnbQ;EDobR,mBAAA;AA4BN;AAzBI;;EACE,cAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AA4BN;AA1BM;;;;EAEE,iBAAA;AA8BR;AAzBE;EACE,gBAAA;AA2BJ;;AAvBA;;;;;EAME,mBAAA;EACA,aAAA;EACA,qCAAA;EAEA,2CAAA;EAEA,sHACE;EAKF,0BAAA;AAkBF;;AAfA;EACE;IACE,sBAAA;EAkBF;EAdI;;IACE,0BAAA;EAiBN;AACF","sourcesContent":["@import \"/src/utilities/variables\";\r\n\r\n.font {\r\n  min-height: 100vh;\r\n  height: 100%;\r\n  background-color: $color_black;\r\n}\r\n\r\nh1,\r\nh2 {\r\n  text-align: center;\r\n}\r\n\r\n.title,\r\n.date {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: $color_black;\r\n  color: #fefcf9;\r\n  height: 50px;\r\n  font-style: italic;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.ticket-all {\r\n  display: flex;\r\n  flex: 2;\r\n  gap: 16px;\r\n  color: white;\r\n  background-color: $color_black;\r\n  height: -webkit-fill-available;\r\n  align-items: stretch;\r\n\r\n  .tickets-home,\r\n  .tickets-road {\r\n    display: flex;\r\n    flex: 1;\r\n    flex-direction: column;\r\n    font-size: 17px;\r\n    font-weight: bold;\r\n    min-height: 200px;\r\n    padding: 16px;\r\n    border-radius: 14px;\r\n    margin-bottom: 10px;\r\n    background: rgba(255, 255, 255, 0.02);\r\n\r\n    h1 {\r\n      color: $color_white;\r\n      font-size: 20px;\r\n      margin-bottom: 18px;\r\n    }\r\n\r\n    .top-players-main-container {\r\n      display: grid;\r\n      grid-template-columns: repeat(3, 1fr);\r\n      gap: 14px;\r\n\r\n      .points-container,\r\n      .assist-container,\r\n      .rebonds-container {\r\n        display: flex;\r\n        flex-direction: column;\r\n      }\r\n\r\n      .stats-card,\r\n      .points-container,\r\n      .assist-container,\r\n      .rebonds-container {\r\n        background: rgba($color_light_blue, 0.3);\r\n        border: 1px solid rgba(255, 255, 255, 0.08);\r\n        border-radius: 12px;\r\n        padding: 14px;\r\n        min-height: 190px;\r\n\r\n        h2 {\r\n          font-size: 18px;\r\n          margin-bottom: 12px;\r\n          color: #fff;\r\n        }\r\n\r\n        .ticket-item,\r\n        .player-item {\r\n          display: flex;\r\n          justify-content: space-between;\r\n          align-items: center;\r\n          gap: 10px;\r\n          padding: 6px 0;\r\n          font-size: 15px;\r\n          line-height: 1.4;\r\n          border-bottom: 1px solid rgba(255, 255, 255, 0.06);\r\n\r\n          &:last-child {\r\n            border-bottom: none;\r\n          }\r\n\r\n          .player-name {\r\n            color: #e5e7eb;\r\n            font-weight: 600;\r\n            line-height: 1.25;\r\n          }\r\n\r\n          .player-value {\r\n            color: #fff;\r\n            font-weight: 800;\r\n            white-space: nowrap;\r\n          }\r\n        }\r\n      }\r\n\r\n      .points-container .player-value {\r\n        color: #22c55e;\r\n      }\r\n\r\n      .assist-container .player-value {\r\n        color: #60a5fa;\r\n      }\r\n\r\n      .rebonds-container .player-value {\r\n        color: #f59e0b;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.ticket-location {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 20px;\r\n\r\n  .stats-card {\r\n        background: rgba($color_light_blue, 0.3);\r\n        border: 1px solid rgba(255, 255, 255, 0.08);\r\n        border-radius: 12px;\r\n        padding: 14px;\r\n        min-height: 5px;\r\n\r\n        .ticket-item{\r\n          display: flex;\r\n          justify-content: space-between;\r\n          align-items: center;\r\n          gap: 10px;\r\n          padding: 6px 0;\r\n          font-size: 15px;\r\n          line-height: 1.4;\r\n          border-bottom: 1px solid rgba(255, 255, 255, 0.06);\r\n\r\n          &:last-child {\r\n            border-bottom: none;\r\n          }\r\n      }\r\n    }\r\n  .tickets-road,\r\n  .tickets-home {\r\n    flex: 1;\r\n    min-width: 0;\r\n\r\n    h1 {\r\n      color: $color_white;\r\n      margin-bottom: 14px;\r\n    }\r\n\r\n    .ticket-item {\r\n      display: block;\r\n      padding: 10px 12px;\r\n      margin-bottom: 10px;\r\n      line-height: 1.8;\r\n      box-sizing: border-box;\r\n\r\n      .badge,\r\n      .play-badge {\r\n        margin-left: 10px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/* zone cartes */\r\n.ticket-sort {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 10px 12px;\r\n  color: white;\r\n  background-color: $color_black;\r\n\r\n  h1 {\r\n    text-align: center;\r\n    margin-bottom: 12px;\r\n    width: 100%;\r\n  }\r\n\r\n  .ticket-card {\r\n    width: 600px;\r\n    // max-width: 00px;\r\n    background: rgba($color_light_blue, 0.3);\r\n    border: 2px solid #2a2a2a;\r\n    border-radius: 14px;\r\n    padding: 10px 14px;\r\n    margin-bottom: 10px;\r\n    color: #fff;\r\n    transition: all 0.2s ease;\r\n    box-sizing: border-box;\r\n\r\n    .ticket-card-top {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      margin-bottom: 8px;\r\n\r\n      .ticket-rank {\r\n        font-size: 18px;\r\n        font-weight: 800;\r\n        line-height: 1;\r\n      }\r\n\r\n      .ticket-scoring {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        flex: 1;\r\n        font-size: 15px;\r\n        font-weight: 700;\r\n        color: #22c55e;\r\n      }\r\n\r\n      .ticket-confidence {\r\n        font-size: 15px;\r\n        font-weight: 700;\r\n        text-align: right;\r\n        color: #60a5fa;\r\n\r\n        &.positive {\r\n          color: #60a5fa;\r\n        }\r\n\r\n        &.negative {\r\n          color: #ef4444;\r\n        }\r\n      }\r\n    }\r\n\r\n    .ticket-context-line {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      margin-bottom: 6px;\r\n\r\n      .ticket-context {\r\n        font-size: 15px;\r\n        color: #bdbdbd;\r\n        font-weight: 600;\r\n        margin-right: 4px;\r\n      }\r\n\r\n      .ticket-badges-right {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 6px;\r\n        flex-wrap: wrap;\r\n        justify-content: flex-end;\r\n      }\r\n    }\r\n\r\n    .ticket-match-line {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: baseline;\r\n      gap: 10px;\r\n      margin-bottom: 4px;\r\n\r\n      .ticket-team {\r\n        font-size: 15px;\r\n        font-weight: 700;\r\n        color: #fff;\r\n        line-height: 1.2;\r\n      }\r\n\r\n      .ticket-opponent {\r\n        font-size: 13px;\r\n        color: #8f8f8f;\r\n        white-space: nowrap;\r\n        text-align: right;\r\n      }\r\n    }\r\n\r\n    .ticket-meta {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      font-size: 14px;\r\n      color: #d0d0d0;\r\n\r\n      .meta-left {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 6px;\r\n      }\r\n\r\n      .meta-right {\r\n        font-weight: 700;\r\n        color: #fff;\r\n      }\r\n\r\n      .separator {\r\n        margin: 0 4px;\r\n        color: #888;\r\n      }\r\n\r\n      .odds {\r\n        color: #fff;\r\n        font-weight: 700;\r\n\r\n        strong {\r\n          font-weight: 800;\r\n          color: #fff;\r\n        }\r\n      }\r\n    }\r\n\r\n    .ticket-model {\r\n      display: flex;\r\n      gap: 12px;\r\n      flex-wrap: wrap;\r\n      font-size: 13px;\r\n      font-weight: 800;\r\n      line-height: 1.2;\r\n\r\n      .delta {\r\n        color: #22c55e;\r\n      }\r\n\r\n      .rank {\r\n        &.positive {\r\n          color: #60a5fa;\r\n        }\r\n\r\n        &.negative {\r\n          color: #ef4444;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.badge,\r\n.play-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 20px;\r\n  padding: 3px 8px;\r\n  border-radius: 999px;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n}\r\n\r\n.play-badge {\r\n  background: rgba(255, 140, 0, 0.15);\r\n  color: #ffb347;\r\n}\r\n\r\n.badge {\r\n  &.under-strong {\r\n    background: linear-gradient(135deg, #1d4ed8, #60a5fa);\r\n    color: #fff;\r\n    border: 1px solid rgba(255, 255, 255, 0.12);\r\n    box-shadow: 0 0 6px rgba(59, 130, 246, 0.45);\r\n  }\r\n\r\n  &.under {\r\n    background: linear-gradient(135deg, #60a5fa, #93c5fd);\r\n    color: #0b1a2b;\r\n    border: 1px solid rgba(255, 255, 255, 0.1);\r\n  }\r\n\r\n  &.over {\r\n    background: linear-gradient(135deg, #fb923c, #f59e0b);\r\n    color: #1f1303;\r\n    border: 1px solid rgba(255, 255, 255, 0.1);\r\n  }\r\n\r\n  &.over-strong {\r\n    background: linear-gradient(135deg, #ef4444, #b91c1c);\r\n    color: #fff;\r\n    border: 1px solid rgba(255, 255, 255, 0.12);\r\n    box-shadow: 0 0 6px rgba(239, 68, 68, 0.45);\r\n  }\r\n\r\n  &.premium,\r\n  &.elite,\r\n  &.core {\r\n    border-radius: 999px;\r\n    padding: 3px 8px;\r\n    font-weight: 800;\r\n    letter-spacing: 0.3px;\r\n  }\r\n\r\n  /* 🥇 PREMIUM = OR */\r\n  &.premium {\r\n    background: linear-gradient(135deg, #ffd700, #facc15);\r\n    color: #000;\r\n    box-shadow: 0 0 6px rgba(255, 215, 0, 0.5);\r\n    transform: scale(1.05);\r\n  }\r\n\r\n  /* 🥈 ELITE = ARGENT */\r\n  &.elite {\r\n    background: linear-gradient(135deg, #d1d5db, #9ca3af);\r\n    color: #000;\r\n    box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);\r\n  }\r\n\r\n  /* 🥉 CORE = BRONZE */\r\n  &.core {\r\n    background: linear-gradient(135deg, #cd7f32, #92400e);\r\n    color: #fff;\r\n    box-shadow: 0 0 4px rgba(205, 127, 50, 0.4);\r\n  }\r\n}\r\n\r\n.ticket-location {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 16px;\r\n\r\n  .tickets-road,\r\n  .tickets-home {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    font-size: 17px;\r\n    font-weight: bold;\r\n    min-height: 200px;\r\n    padding: 10px;\r\n    border-radius: 8px;\r\n    margin-bottom: 10px;\r\n\r\n    h1 {\r\n      color: $color_white;\r\n      margin-bottom: 12px;\r\n    }\r\n\r\n    .ticket-item {\r\n      display: block;\r\n      padding: 6px 0;\r\n      font-size: large;\r\n      line-height: 1;\r\n\r\n      .badge,\r\n      .play-badge {\r\n        margin-left: 10px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .tickets-home {\r\n    margin-left: 5px;\r\n  }\r\n}\r\n\r\n.ticket-road,\r\n.ticket-home,\r\n/* 🔥 style commun à tous les blocs principaux */\r\n.tickets-road,\r\n.tickets-home,\r\n.ticket-sort {\r\n  border-radius: 14px;\r\n  padding: 14px;\r\n  background: rgba(255, 255, 255, 0.02);\r\n\r\n  border: 1px solid rgba(255, 255, 255, 0.08);\r\n\r\n  box-shadow:\r\n    0 0 15px rgba(255, 255, 255, 0.12),\r\n    0 0 40px rgba(255, 255, 255, 0.08),\r\n    0 0 80px rgba(255, 255, 255, 0.04);\r\n\r\n  // margin-bottom: 20px;\r\n  transition: all 0.25s ease;\r\n}\r\n\r\n@media (max-width: 1100px) {\r\n  .ticket-all {\r\n    flex-direction: column;\r\n\r\n    .tickets-home,\r\n    .tickets-road {\r\n      .top-players-main-container {\r\n        grid-template-columns: 1fr;\r\n      }\r\n    }\r\n  }\r\n}","$color_black: #000215;\r\n$color_dark_blue: #011d44;\r\n$color_light_blue: #81c0e4;\r\n$color_purple: #c4c5ea;\r\n$color_white: #fefcf9;\r\n$header_height: 50px;\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
